const media = {
  mobile: `@media screen and (max-width: 320px)`,
  tablet: `@media screen and (min-width: 768px)`,
  desktop: `@media screen and (min-width: 1280px)`,
  widescreen: `@media screen and (min-width: 1920px)`,
};

const shadows = {
  button: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  cardShadow: '0px 6px 16px rgba(0, 0, 0, 0.05)',
  clientEllipse: '0px 2px 10px rgba(0, 0, 0, 0.05)',
  logoShadow: '0px 8px 20px rgba(0, 0, 0, 0.15)',
};

export { shadows, media };
